import "../../../assets/scss/logged-in-avatar-style.scss";
import React from "react";
import { googleLogout } from "@react-oauth/google";
import { Avatar, Divider, Dropdown, MenuProps } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UserOutlined } from "@ant-design/icons";

import { useAppDispatch, useAppSelector } from "../../store/hooks";

import { LangComp } from "../LangComp";
import { useAuth } from "../../utility/AuthContext";

import { removeInstance } from "../../features/instance/instanceSlice";
import { removeSelectionInfo } from "../../features/selection/selectionSlice";
import { removeUserInfo } from "../../features/user/userSlice";
import { clearAllSessions } from "../../utility/common/session-store";
import { updateMenuKey } from "../../features/settings/settingsSlice";

interface LoggedInAvatarType {
  type?: string;
}

const loggedInAvatarList = {
  en: "EN",
  zh_tw: "繁體中文",
  vn: "Tiếng Việt",
};

export const LoggedInAvatar = (props: LoggedInAvatarType) => {
  const { t } = useTranslation();
  const { isLoggedIn, setShowLoginModal, logout } = useAuth();
  const userEmail = useAppSelector((state: any) => state.user.email);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const navigateLink = (menuKey: number, param: string) => {
    dispatch(updateMenuKey(menuKey));
    navigate(param);
  };

  const handleLogOut = () => {
    logout();
    googleLogout();
    document.cookie =
      "g_state=; path=/; domain=.google.com; expires=Thu, 01 Jan 1970 00:00:00 GMT";
    dispatch(removeUserInfo());
    dispatch(removeInstance());
    dispatch(removeSelectionInfo());
    clearAllSessions();
    if (location.pathname === "/") {
      window.location.reload();
    } else {
      navigate("/", { replace: true });
    }
  };

  const items: MenuProps["items"] = [
    {
      key: "0",
      label: (
        <>
          <span>{userEmail}</span>
          <Divider style={{ margin: 0 }} />
        </>
      ),
    },
    {
      key: "1",
      label: (
        <div onClick={() => navigateLink(6, "/account")}>
          {t("Profile Setting")}
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <>
          <LangComp />
        </>
      ),
    },
    {
      key: "3",
      label: <span onClick={handleLogOut}>{t("Log Out")}</span>,
    },
  ];

  return (
    <>
      {isLoggedIn ? (
        <Dropdown
          className="avatar-drop"
          menu={{ items }}
          dropdownRender={(menu) => (
            <div className="credit-balance-menu">
              {React.cloneElement(
                menu as React.ReactElement<{
                  style: React.CSSProperties;
                }>
              )}
            </div>
          )}
          trigger={["click"]}
        >
          <div>
            <a data-no-auth onClick={(e) => e.preventDefault()}>
              {/* <span>{userState}</span> */}
              <Avatar icon={<UserOutlined />} />
            </a>
          </div>
        </Dropdown>
      ) : (
        <div
          data-no-auth
          className="primary-btn"
          style={{ cursor: "pointer" }}
          onClick={() => setShowLoginModal(true)}
        >
          {t("Log In")}
        </div>
      )}
    </>
  );
};
